import type { PostInterface } from 'modules/community/types/post-interface'
import type { PostPinnedToType } from 'modules/community/types/post-pinned-to-type'

export const isPinnedIn = (post: PostInterface, source: PostPinnedToType): boolean =>
  post.pinnedTo.includes(source)
